// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__20iE5","tab":"ProcedureTabs_tab__2SENY"};